type HighlightTextStyles = Readonly<{
	pillBackgroundClass: string;
	selectedPillBackgroundClass: string;
	bandBackgroundClass: string;
	selectedBandBackgroundClass: string;
	textClass: string;
	selectedTextClass: string;
	iconClass: string;
	selectedIconClass: string;
}>;

type Result = ModelHookResult<HighlightTextStyles, undefined>;

const HIGHLIGHT_TEXT_STYLES: HighlightTextStyles = {
	pillBackgroundClass: 'bg-fill-weaker',
	selectedPillBackgroundClass: 'bg-fill-information-strong',
	bandBackgroundClass: 'bg-transparent',
	selectedBandBackgroundClass: 'bg-fill-information-weaker',
	textClass: 'text-typography-strong',
	selectedTextClass: 'text-typography-inverse-strong',
	iconClass: 'text-icon-strong',
	selectedIconClass: 'text-icon-inverse-strong',
};

export function useHighlightText(): Result {
	return { data: HIGHLIGHT_TEXT_STYLES };
}
